export const TRIBUTARY_TYPES = {
    CUIT: 'cuit',
    CNPJ: 'cnpj',
    RUT: 'rut',
    NIT: 'nit',
    RUC: 'ruc',
    DIMEX: 'dimex',
    RFC: 'rfc',
    DNI: 'dni',
    CEDULA: 'cedula',
    CEDULA_JURIDICA: 'cedula juridica',
    CEDULA_FISICA: 'cedula fisica',
};
export const TRIBUTARY_TYPES_LABELS = {
    CUIT: 'CUIT',
    CNPJ: 'CNPJ',
    RUT: 'RUT',
    NIT: 'NIT',
    RUC: 'RUC',
    DIMEX: 'DIMEX',
    RFC: 'RFC',
    DNI: 'DNI',
    CEDULA: 'Cédula',
    CEDULA_JURIDICA: 'Cédula Jurídica',
    CEDULA_FISICA: 'Cédula Física',
};
export const TRIBUTARY_TYPES_BY_COUNTRY = {
    AR: [{ label: TRIBUTARY_TYPES_LABELS.CUIT, value: TRIBUTARY_TYPES.CUIT }],
    BR: [{ label: TRIBUTARY_TYPES_LABELS.CNPJ, value: TRIBUTARY_TYPES.CNPJ }],
    CL: [{ label: TRIBUTARY_TYPES_LABELS.RUT, value: TRIBUTARY_TYPES.RUT }],
    CO: [
        { label: TRIBUTARY_TYPES_LABELS.RUT, value: TRIBUTARY_TYPES.RUT },
        { label: TRIBUTARY_TYPES_LABELS.NIT, value: TRIBUTARY_TYPES.NIT },
    ],
    CR: [
        { label: TRIBUTARY_TYPES_LABELS.CEDULA_FISICA, value: TRIBUTARY_TYPES.CEDULA_FISICA },
        { label: TRIBUTARY_TYPES_LABELS.CEDULA_JURIDICA, value: TRIBUTARY_TYPES.CEDULA_JURIDICA },
        { label: TRIBUTARY_TYPES_LABELS.DIMEX, value: TRIBUTARY_TYPES.DIMEX },
    ],
    EC: [{ label: TRIBUTARY_TYPES_LABELS.RUC, value: TRIBUTARY_TYPES.RUC }],
    MX: [{ label: TRIBUTARY_TYPES_LABELS.RFC, value: TRIBUTARY_TYPES.RFC }],
    PE: [{ label: TRIBUTARY_TYPES_LABELS.RUC, value: TRIBUTARY_TYPES.RUC }],
    UY: [{ label: TRIBUTARY_TYPES_LABELS.RUT, value: TRIBUTARY_TYPES.RUT }],
};
export const IDENTITIES_VALIDATIONS = {
    AR: {
        CUIT: {
            onlyDigits: true,
            regex: '^([0-9]{2}[0-9]{8}[0-9]{1})$',
            min: 11,
            max: 11,
            mask: 'XX-XXXXXXXX-X',
            requiredMaskForValidation: false,
        },
    },
    BR: {
        CNPJ: {
            regex: '^[0-9]{2}[0-9]{3}[0-9]{3}[0-9]{4}[0-9]{2}$',
            onlyDigits: true,
            min: 14,
            max: 14,
            mask: 'XX.XXX.XXX/XXXX-XX',
            requiredMaskForValidation: true,
        },
    },
    CO: {
        RUT: {
            onlyDigits: true,
            min: 0,
            max: 20,
            // TODO: Use Commented values
            // min: 5,
            // max: 11,
            // mask: 'XXXXXXXXXXX',
        },
        NIT: {
            regex: '^([1-9]\\d{6,11}[0-9])$',
            onlyDigits: true,
            min: 8,
            max: 13,
            mask: 'XXXXXXXXXXXXX',
        },
    },
    MX: {
        RFC: {
            regex: '^([A-Za-zÑñ&]{3,4})(\\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\\d|3[01]))([A-Za-z\\d]{3})$',
            min: 12,
            max: 13,
            onlyDigits: false,
            mask: 'XXXXXXXXXXXXX',
            requiredMaskForValidation: false,
        },
    },
    CR: {
        'CEDULA JURIDICA': {
            onlyDigits: true,
            min: 10,
            max: 10,
            mask: 'X-XXX-XXXXXX',
        },
        'CEDULA FISICA': {
            onlyDigits: true,
            min: 9,
            max: 10,
            mask: 'X XXXX XXXXX',
        },
        DIMEX: {
            onlyDigits: false,
            min: 3,
            max: 20,
            mask: 'XXXXXXXXXXXXXXXXXXXX',
        },
    },
    CL: {
        RUT: {
            onlyDigits: false,
            regex: '^([0-9]{8})([0-9]|K|k)$',
            min: 9,
            max: 12,
            // TODO: Use Commented values when DB is updated
            // mask: 'XX.XXX.XXX-X',
            // min: 9,
            // max: 9,
            requiredMaskForValidation: false,
        },
    },
    EC: {
        RUC: {
            onlyDigits: true,
            regex: '^([0-1][0-9]|2[0-4])([0-6]|9)([0-9]{10})$',
            min: 13,
            max: 13,
            mask: 'XXXXXXXXXXXXX',
            requiredMaskForValidation: false,
        },
    },
    PE: {
        RUC: {
            onlyDigits: true,
            regex: '^(10|20|[1][5-7])([0-9]{9})$',
            min: 11,
            max: 11,
            mask: 'XXXXXXXXXXX',
            requiredMaskForValidation: false,
        },
    },
    UY: {
        RUT: {
            onlyDigits: true,
            regex: '^([0-9]{2})([0-9]{6})([0-9]{3})[0-9]$',
            min: 10,
            max: 12,
            mask: 'XXXXXXXXXXXX',
            requiredMaskForValidation: false,
        },
    },
};
